export default __webpack_public_path__ + "static/media/photo--sm--53.2afb9a5b.jpg";